<template lang="pug">
.sidemenu
  .sidemenu-overlay(@click="closeSideMenu")
  .sidemenu-content
    .sidemenu-close.show--smallScreens
      i.icon-sidemenu-close(@click="closeSideMenu")
    ul.sidemenu-list
      li.sidemenu-item.show--smallScreens
        .sidemenu-action.color--blueCornFlower(@click="login('/')" v-if='!token') {{loginStatus.login}}
        .sidemenu-user(v-else)
          .sidemenu-imageUser(v-if="userProfile.pictureUrl" :style='"background-image: url(" + userProfile.pictureUrl + ")"')
          .sidemenu-imageUser(v-else :style="defaultImage")
          span.sidemenu-nameUser {{ userProfile.displayName }}
          .sidemenu-action.color--blueCornFlower(v-if='showLogout' @click='logout') {{loginStatus.logout}}

      li.sidemenu-item(@click="checkActive")
        router-link.sidemenu-link#menu-main(v-if="type=='users'" to='/') {{sidemenu.pages.main}}
        router-link.sidemenu-link#menu-main(v-else-if="type=='partners'" to='/') {{sidemenu.pages.partnerMain}}

      li.sidemenu-item(v-if="type=='users'" @click="checkActive")
        router-link.sidemenu-link#latestArticles(:to='{ path: "/category", query: { type: "latestArticles"}}') {{sidemenu.pages.latest}}

      li.sidemenu-item(v-if="type=='users'" @click="checkActive")
        a.sidemenu-link(:class='unfolded? "sidemenu-unfold": "sidemenu-fold"' href="javascript:void(0)" @click='fold') {{sidemenu.pages.category}}
        ul.sidemenu-subList(v-if='unfolded')
          li.sidemenu-subItem(v-for="item in sidemenu.pages.categories")
            router-link.sidemenu-link(v-if="item.id === '0'" :id='"menu-category-" + item.id' :to='{ path: "/gov-announces"}') {{item.name}}
            router-link.sidemenu-link(v-else :id='"menu-category-" + item.id' :to='{ path: "/category", query: { type: "latestArticlesByCategory", categoryId: item.id}}') {{item.name}}
      li.sidemenu-item(v-else-if="type=='government'" @click="checkActive")
        router-link.sidemenu-link#menu-category-0(:to='{ path: "/gov-announces"}')  {{ sidemenu.pages.categories[8].name }}

      li.sidemenu-item(v-if="type === 'users'" @click="checkActive")
        router-link.sidemenu-link#menu-verified(:to='{ path: "/category", query: { type: "verified"}}')  {{sidemenu.pages.verified}}
      li.sidemenu-item(v-if="type === 'partners'" @click="checkActive")
        router-link.sidemenu-link#menu-verified(:to='{ path: "/category", query: { type: "partnerVerified"}}')  {{sidemenu.pages.verified}}

      li.sidemenu-item.sidemenu-lastchild(v-if="type === 'users'" @click="checkActive")
        router-link.sidemenu-link#menu-following(v-if="token" :to='{ path: "/category", query: { type: "followingArticles"}}') {{sidemenu.pages.follow}}
        a.sidemenu-link(v-else @click="login('/category?type=followingArticles')") {{sidemenu.pages.follow}}
      li.sidemenu-item(v-else-if="type === 'partners'" @click="checkActive")
        router-link.sidemenu-link#menu-following(v-if="token" :to='{ path: "/category", query: { type: "partnerFollowingArticles"}}') {{sidemenu.pages.follow}}
        a.sidemenu-link(v-else @click="login('/category?type=partnerFollowingArticles')") {{sidemenu.pages.follow}}
      li.sidemenu-item.sidemenu-lastchild(v-if="type === 'partners'" @click="checkActive")
        router-link.sidemenu-link#menu-dashboard(v-if="token" :to='{ path: "/dashboard"}') {{sidemenu.pages.reports}}
        a.sidemenu-link(v-else @click="login('/dashboard')") {{sidemenu.pages.reports}}

    ul.sidemenu-list(v-if="type === 'users'")
      li.sidemenu-item(v-for="item in sidemenu.help" @click="checkActive")
        router-link.sidemenu-link(:to="item.link" :id='item.id') {{item.name}}

    .sidemenu-qrcode(v-if="type === 'users'")
      .icon-qrcode
      .sidemenu-textQrcode
        p.color--black.text--16
          |  加入官方帳號
          br
          | 一起協助查證
      .sidemenu-markQrcode
        .icon-badge
        .sidemenu-textMarkQrcode.color--black90  {{sidemenu.oa.name}}

    .sidemenu-closing(v-if="type === 'users'")
      .sidemenu-copyright
        h4.text--14.color--black30 © LINE Taiwan Limited
      .sidemenu-social
        a.sidemenu-socialIcon.icon-line(:href='"https://social-plugins.line.me/lineit/share?url=" + $store.state.URLs.base'
          target="_blank")
        a.sidemenu-socialIcon.icon-facebook(:href='"https://www.facebook.com/sharer/sharer.php?u=" + $store.state.URLs.base'
          target="_blank")
</template>

<script>
import { login, logout } from '@/plugins/login.js';
import { setGtag } from '@/plugins/gtag.js';
import $ from 'jquery';

export default {
  props: {
    sidemenu: Object,
    token: String,
    userProfile: Object,
    loginStatus: Object,
    type: String
  },
  data() {
    return {
      isCollapse: false,
      unfolded: false
    };
  },
  computed: {
    defaultImage() {
      return (
        "background-image: url('" +
        process.env.VUE_APP_CDN_URL +
        "/upload/avatar-empty-80-x-80%403x.png');"
      );
    },
    showLogout() {
      return !this.$store.state.isLiff;
    }
  },
  created() {
    if (
      (this.$route.path === '/category' &&
        this.$route.query.type === 'latestArticlesByCategory') ||
      this.$route.path === '/gov-announces'
    )
      this.unfolded = true;
  },
  mounted() {
    this.checkActive(true);
  },
  methods: {
    login(lastVisit) {
      login(this.$store.state, lastVisit);
    },
    logout() {
      logout(this.$store.state);
    },
    fold() {
      this.unfolded = !this.unfolded;
    },
    activeCategory(isNewPage) {
      const query = this.$route.query;
      switch (query.type) {
        case 'latestArticles':
          this.active('#latestArticles');
          setGtag('click', 'menu', '最新話題', '最新話題', !isNewPage);
          break;
        case 'latestArticlesByCategory':
          this.active('#menu-category-' + query.categoryId);
          setGtag(
            'click',
            'menu',
            '分類話題 - ' + $('#menu-category-' + query.categoryId).text(),
            '',
            !isNewPage
          );
          break;
        case 'verified':
          this.active('#menu-verified');
          setGtag('click', 'menu', '已查核', '已查核', !isNewPage);
          break;
        case 'partnerVerified':
          this.active('#menu-verified');
          break;
        case 'followingArticles':
        case 'partnerFollowingArticles':
          this.active('#menu-following');
          setGtag('click', 'menu', '關注中', '關注中', !isNewPage);
          break;
      }
    },
    active(id) {
      const activeClass = 'sidemenu-link--active';
      $(id).addClass(activeClass);
    },
    checkActive(isNewPage) {
      if (isNewPage !== true) isNewPage = false;
      switch (this.$route.path) {
        case '/':
          this.active('#menu-main');
          setGtag('click', 'menu', '首頁', '首頁', !isNewPage);
          break;
        case '/how-to-use':
          this.active('#menu-how-to-use');
          setGtag('click', 'menu', '如何使用', '如何使用', !isNewPage);
          break;
        case '/media':
          this.active('#menu-media');
          setGtag('click', 'menu', '媒體識讀', '媒體識讀', !isNewPage);
          break;
        case '/partners':
        case '/partner':
          this.active('#menu-partners');
          setGtag('click', 'menu', '合作夥伴', '合作夥伴', !isNewPage);
          break;
        case '/category':
          this.activeCategory(!isNewPage);
          break;
        case '/news':
          this.active('#menu-category-' + this.$route.query.categoryId);
          break;
        case '/gov-announces':
          this.active('#menu-category-0');
          setGtag('click', 'menu', '公共事務', '公共事務', !isNewPage);
          break;
        case '/dashboard':
          this.active('#menu-dashboard');
          break;
        default:
          this.active('#menu-main');
      }
    },
    closeSideMenu() {
      document.querySelector('.sidemenu').classList.remove('sidemenu--active');
    }
  }
};

(function(d, s, id) {
  var js,
    fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) return;
  js = d.createElement(s);
  js.id = id;
  js.src = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.0';
  fjs.parentNode.insertBefore(js, fjs);
})(document, 'script', 'facebook-jssdk');
</script>
